import LogoIcon from "../../../components/fundamentals/icons/logo-icon";
import SigninInput from "../../../components/form/input-signin";
import Button from "../../../components/fundamentals/button";
import {useForm, UseFormHandleSubmit, UseFormRegister} from "react-hook-form";

export type AuthFormData = {
    email: string,
    password: string,
    token: string,
}

type AuthFormProps = {
    isLoading: boolean,
    onSubmit: (data: Partial<AuthFormData>) => Promise<void>,
    context: "validate"|"reset",
    errorMessage: string,
}

// RAG-56 : règle de mot de passe (alignée sur l'API, RAG-34) affichée et validée côté écran,
// en français, pour que l'utilisateur sache tout de suite ce qui manque.
const PASSWORD_RULE =
    "Au moins 12 caractères, avec une majuscule, une minuscule, un chiffre et un caractère spécial.";

function passwordError(value: string): string | true {
    const missing: string[] = [];
    if (value.length < 12) missing.push("12 caractères minimum");
    if (!/[A-Z]/.test(value)) missing.push("une majuscule");
    if (!/[a-z]/.test(value)) missing.push("une minuscule");
    if (!/[0-9]/.test(value)) missing.push("un chiffre");
    if (!/[^A-Za-z0-9]/.test(value)) missing.push("un caractère spécial");

    return missing.length ? "Il manque : " + missing.join(", ") + "." : true;
}

function AuthForm({isLoading, onSubmit, context, errorMessage}: AuthFormProps) {

    const {
        register,
        formState: {errors, isValid},
        handleSubmit
    } = useForm<AuthFormData>({mode: "onChange"});

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col items-center">

                <LogoIcon />
                <span className="inter-2xlarge-semibold mt-4 text-grey-90">
                                Bienvenue
                            </span>
                <span className="inter-base-regular text-grey-50 mb-xlarge">
                                {context === "validate"
                                    ? "Confirmez votre compte ci-dessous"
                                    : "Réinitialisez votre mot de passe ci-dessous"
                                }
                            </span>
                <SigninInput
                    placeholder="Entrez votre email..."
                    {...register("email", { required: true, pattern: {value: /^.+@.+\.\w{2,4}$/, message: "Email invalide"}})}
                    autoComplete="email"
                />
                <SigninInput
                    placeholder="Mot de passe..."
                    type={"password"}
                    {...register("password", { required: true, validate: passwordError })}
                    autoComplete="new-password"
                />
                <span className="text-grey-50 w-full mt-1 inter-small-regular">
                    {PASSWORD_RULE}
                </span>
                {errors.password &&
                    <span className="text-rose-50 w-full mt-1 inter-small-regular">
                        {errors.password.message}
                    </span>
                }
                {errorMessage &&
                    <span className="text-rose-50 w-full mt-2 inter-small-regular">
                        {errorMessage}
                    </span>
                }
                <Button
                    className="rounded-rounded mt-4 w-[320px] inter-base-regular"
                    variant="primary"
                    size="large"
                    type="submit"
                    disabled={!isValid}
                    loading={isLoading}
                >
                    Continuer
                </Button>
            </div>
        </form>
    )
}

export default AuthForm